import { routes } from '../../lib/routes';
import { callApi } from '../utils';

const basePath = (skillId: string) => `/v3/alice-agent-apps/${skillId}`;

export interface AgentAppShareUser {
    login: string;
    uid: string;
}

export const getDraftShares = (skillId: string) =>
    callApi<AgentAppShareUser[]>({
        method: 'GET',
        url: routes.app.appStoreApi(`${basePath(skillId)}/draft/shares`),
    });

// 4xx: validationErrors с типами VALIDATION_ERROR / LOGIN_NOT_FOUND
export const addDraftShare = (skillId: string, login: string) =>
    callApi<AgentAppShareUser>({
        method: 'POST',
        url: routes.app.appStoreApi(`${basePath(skillId)}/draft/shares`),
        data: { login },
    });

// Идемпотентно: если шеринга нет — всё равно 200
export const deleteDraftShare = (skillId: string, userId: string) =>
    callApi<string>({
        method: 'DELETE',
        url: routes.app.appStoreApi(`${basePath(skillId)}/draft/shares/${userId}`),
    });

// Каждый вызов выписывает новый ключ — старая ссылка перестаёт работать
// 4xx: SHARE_REQUIRES_PUBLISHED_APP если onAir=false
export const createOrUpdatePublicShare = (skillId: string) =>
    callApi<string>({
        method: 'POST',
        url: routes.app.appStoreApi(`${basePath(skillId)}/shares/public`),
    });
